import { render } from "./TheC01ItemThumbnailsPc.vue?vue&type=template&id=3f38f0d4&scoped=true&ts=true"
import script from "./TheC01ItemThumbnailsPc.vue?vue&type=script&lang=ts"
export * from "./TheC01ItemThumbnailsPc.vue?vue&type=script&lang=ts"

import "./TheC01ItemThumbnailsPc.vue?vue&type=style&index=0&id=3f38f0d4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f38f0d4"]])

export default __exports__